import React from "react";
import styled from "styled-components";
import { HiddenAccessibleSpan } from "../../../components/accessibility/hidden_accessible_span";
import DOMPurify from "dompurify";
import { RequiredMarker, StyledQuestionPrompt, StyledDescription } from "./shared_styles";

const StyledLegend = styled.legend`
  display: inline-block;
  font-weight: 300;
  font-size: 18px;
  margin-bottom: 12px;
  white-space: pre-wrap;
`;

export const StyledFieldset = styled.fieldset`
  border: none;
  padding: 0;
`;

export default function QuestionFieldsetLegend({
  legend,
  description,
  questionIsOptional = false,
  hideRequiredMarker = false,
  dataTest,
  htmlFor,
  ...rest
}: {
  legend: string;
  description?: string;
  questionIsOptional?: boolean;
  className?: string;
  hideRequiredMarker?: boolean;
  dataTest?: string;
  htmlFor?: string;
}) {
  return (
    <>
      {/* We're moving away from required indicators as a UX choice, but won't do the refactor en masse. This flag allows us to update some areas incrementally */}
      <StyledLegend {...rest}>
        {!questionIsOptional && !hideRequiredMarker && (
          <>
            <RequiredMarker aria-hidden={true}>* </RequiredMarker>
            <HiddenAccessibleSpan>Required</HiddenAccessibleSpan>
          </>
        )}
        <StyledQuestionPrompt
          htmlFor={htmlFor}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(legend, { ALLOWED_ATTR: ["href", "aria-label", "target"] }),
          }}
        />
      </StyledLegend>

      {description && (
        <StyledDescription
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(description, {
              ALLOWED_ATTR: ["href", "aria-label", "target"],
            }),
          }}
        ></StyledDescription>
      )}
    </>
  );
}
